module.exports = __webpack_public_path__ + "img/female-user.2d4702c0.svg";